import { render } from "./DataExplorerLink.vue?vue&type=template&id=2427bb34&scoped=true"
import script from "./DataExplorerLink.vue?vue&type=script&lang=ts"
export * from "./DataExplorerLink.vue?vue&type=script&lang=ts"

import "./DataExplorerLink.vue?vue&type=style&index=0&id=2427bb34&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2427bb34"

export default script